// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carnet {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    grid-column-start: 1;
    grid-column-end: 13;
    position: fixed;
    width: 100%;
}
.carnet__menu,
.carnet__test-data {
    width: 270px;
    min-width: 270px;
    height: 130vh;
    background: var(--white-color);
    padding: 12px;
    border-top: 1px solid var(--new-gray-background-color);
}

.carnet__info-message {
    display: flex;
    align-items: flex-start;
    background: var(--new-informative-banner-bg-color);
    padding: 6px;
    border-radius: 4px;
}

.carnet__info-message .baloa-username{
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
}

.carnet__info-message .hubicon-info::before {
    font-size: 22px;
    margin-right: 8px;
    color:  var( --new-informative-banner-color);
}

.carnet__options-elements {
    padding: 6px;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 4px;
    cursor: pointer;
    margin-top: 10px;
    width: fit-content;
}

.carnet__options-elements.image {
    width: 90px;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.carnet__options-elements .baloa-table {
    color: var(--primary-very-dark-color);
}

.carnet__options-elements.disabled {
    background: var(--new-gray-disabled-color);
}

.carnet__board {
    width: -webkit-fill-available;
}

.carnet__board__buttons,
.carnet__board__options {
    background: var(--white-color);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid var(--new-gray-background-color);
    border-left: 1px solid var(--new-gray-background-color);
    border-right: 1px solid var(--new-gray-background-color);
    gap: 24px;
}

.carnet__board__buttons {
    padding: 16px;
}

.carnet__board__options {
    padding: 8px;
}

.carnet__board__options .baloa-username {
    color: var(--primary-very-dark-color);
}

.carnet__board__options .MuiOutlinedInput-notchedOutline {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.carnet__board__options .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline  {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.carnet__board__options .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: var(--new-gray-background-color);
}

.carnet__board__options .MuiOutlinedInput-root {
    width: 208px;
}

.carnet__board__options .MuiOutlinedInput-input {
    padding: 12px 8px;  
}

.carnet__board__options .MuiListItemText-root {
    margin-top: 0;
    margin-bottom: 0;
}

.carnet__board__options__color-picker__button {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    padding: 8px;
    width: 46px;
    height: 46px;
}

.carnet__board__buttons__preview-btn {
    padding: 8px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    cursor: pointer;
    margin-right: 18px;
}

.carnet__board__buttons__preview-btn .hubicon-preview {
    color: var(--primary-dark-color);
    font-size: 22px;
}

.carnet__board__buttons__preview-btn .baloa-table {
    color: var(--primary-dark-color);
}

.carnet__save-button.button.small {
    padding: 8px 12px;
}

.carnet__save-button .icon{
    grid-area: icon;
    font-size: 22px;
    margin-right: 8px;
}

.carnet__save-button .hubicon-save::before {
    color: var(--white-color);
}

.carnet__canvas-parent {
    display: flex;
    justify-content: center;
    padding-top: 48px;
    height: calc(130vh - 140px);
    padding-bottom: 70px;
}

.carnet__canvas {
    width: 318pt;    
    height: 176.25pt;
    position: relative;    
    zoom: 200%;
    border-radius: 10px;
    background: var(--white-color);
}

.carnet__canvas.vertical {
    width: 205.50pt;    
    height: 290.55pt;
    min-width: 205.50pt;    
    min-height: 290.55pt;
}

.carnet-data {
    /* padding: 5px; */
    width: fit-content;
    position: absolute;
    cursor: pointer;
    z-index: 4;
}

.carnet-data.test-image {
    padding: 0;
}

.carnet-data.selected{
    border: 1px solid var(--new-green-color);
}

.carnet-data.baloa-table {
    color: var(--primary-very-dark-color);
    font-size: 12pt;
}

.carnet-data.image {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--new-gray-background-color);
}

.carnet-data.image.selected {
    border: 1px solid var(--new-green-color);
}

.carnet-data.image.round {
    border-radius: 50%;
}

.carnet-data.test-image{
    width: inherit;
    height: inherit;
}

.carnet-data.test-image img{
    aspect-ratio: 1;
    object-fit: cover;
    width: inherit;
    height: inherit;
    border-radius: inherit;
}

.carnet-data.test-image.selected {
    padding: 0;
    border: 1px solid var(--new-green-color);
}

.carnet-data.test-image.round {
    border-radius: 50%;
}

.carnet__test-data__element {
    margin-top: 10px;
}

.carnet__test-data__element .baloa-username {
    color: var(--primary-very-dark-color);
    margin-bottom: 4px;
}

.carnet__test-data__input.MuiFormControl-root {
    width: 100%;
}

.carnet__test-data__input .MuiOutlinedInput-input {
    padding: 12px 8px;
}

.carnet__test-data__input .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.carnet__test-data__input .MuiOutlinedInput-notchedOutline {
    border: 1px solid var(--new-gray-background-color);
    border-color: var(--new-gray-background-color);
    border-radius: 8px;
}
.carnet__test-data__input .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: var(--new-gray-background-color);
    border-width: 1px;
}

.carnet__test-data__element__file-input__delete-file {
    display: flex;
    align-items: center;
    margin-top: 5px;
}

.carnet__test-data__element__file-input__delete-file-icon {
    padding: 2px 0 0 0;
    min-width: var( --space-and-half );
    max-width: var( --space-and-half );
    height: var( --space-and-half );
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var( --new-gray-background-color );
    color: var( --primary-dark-color );
}

.carnet-print__image {
    width: 115px;
    height: 115px;
    border-radius: 50%;
}
.carnet-preview{
    width: 540px;
    height: 300px;
    position: relative;
    border: 1px solid gray;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-cardid-creator/TournamentCardIdCreatorComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;AACA;;IAEI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,sDAAsD;AAC1D;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kDAAkD;IAClD,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,4CAA4C;AAChD;;AAEA;IACI,YAAY;IACZ,kDAAkD;IAClD,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;IAEI,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sDAAsD;IACtD,uDAAuD;IACvD,wDAAwD;IACxD,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kDAAkD;AACtD;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,kDAAkD;IAClD,8CAA8C;IAC9C,kBAAkB;AACtB;AACA;IACI,8CAA8C;IAC9C,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,kCAAkC;IAClC,+BAA+B;IAC/B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oDAAoD;IACpD,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,sBAAsB;AAC1B","sourcesContent":[".carnet {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    grid-column-start: 1;\n    grid-column-end: 13;\n    position: fixed;\n    width: 100%;\n}\n.carnet__menu,\n.carnet__test-data {\n    width: 270px;\n    min-width: 270px;\n    height: 130vh;\n    background: var(--white-color);\n    padding: 12px;\n    border-top: 1px solid var(--new-gray-background-color);\n}\n\n.carnet__info-message {\n    display: flex;\n    align-items: flex-start;\n    background: var(--new-informative-banner-bg-color);\n    padding: 6px;\n    border-radius: 4px;\n}\n\n.carnet__info-message .baloa-username{\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n}\n\n.carnet__info-message .hubicon-info::before {\n    font-size: 22px;\n    margin-right: 8px;\n    color:  var( --new-informative-banner-color);\n}\n\n.carnet__options-elements {\n    padding: 6px;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 4px;\n    cursor: pointer;\n    margin-top: 10px;\n    width: fit-content;\n}\n\n.carnet__options-elements.image {\n    width: 90px;\n    height: 90px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.carnet__options-elements .baloa-table {\n    color: var(--primary-very-dark-color);\n}\n\n.carnet__options-elements.disabled {\n    background: var(--new-gray-disabled-color);\n}\n\n.carnet__board {\n    width: -webkit-fill-available;\n}\n\n.carnet__board__buttons,\n.carnet__board__options {\n    background: var(--white-color);\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-top: 1px solid var(--new-gray-background-color);\n    border-left: 1px solid var(--new-gray-background-color);\n    border-right: 1px solid var(--new-gray-background-color);\n    gap: 24px;\n}\n\n.carnet__board__buttons {\n    padding: 16px;\n}\n\n.carnet__board__options {\n    padding: 8px;\n}\n\n.carnet__board__options .baloa-username {\n    color: var(--primary-very-dark-color);\n}\n\n.carnet__board__options .MuiOutlinedInput-notchedOutline {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.carnet__board__options .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline  {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.carnet__board__options .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n    border-color: var(--new-gray-background-color);\n}\n\n.carnet__board__options .MuiOutlinedInput-root {\n    width: 208px;\n}\n\n.carnet__board__options .MuiOutlinedInput-input {\n    padding: 12px 8px;  \n}\n\n.carnet__board__options .MuiListItemText-root {\n    margin-top: 0;\n    margin-bottom: 0;\n}\n\n.carnet__board__options__color-picker__button {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    padding: 8px;\n    width: 46px;\n    height: 46px;\n}\n\n.carnet__board__buttons__preview-btn {\n    padding: 8px 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    cursor: pointer;\n    margin-right: 18px;\n}\n\n.carnet__board__buttons__preview-btn .hubicon-preview {\n    color: var(--primary-dark-color);\n    font-size: 22px;\n}\n\n.carnet__board__buttons__preview-btn .baloa-table {\n    color: var(--primary-dark-color);\n}\n\n.carnet__save-button.button.small {\n    padding: 8px 12px;\n}\n\n.carnet__save-button .icon{\n    grid-area: icon;\n    font-size: 22px;\n    margin-right: 8px;\n}\n\n.carnet__save-button .hubicon-save::before {\n    color: var(--white-color);\n}\n\n.carnet__canvas-parent {\n    display: flex;\n    justify-content: center;\n    padding-top: 48px;\n    height: calc(130vh - 140px);\n    padding-bottom: 70px;\n}\n\n.carnet__canvas {\n    width: 318pt;    \n    height: 176.25pt;\n    position: relative;    \n    zoom: 200%;\n    border-radius: 10px;\n    background: var(--white-color);\n}\n\n.carnet__canvas.vertical {\n    width: 205.50pt;    \n    height: 290.55pt;\n    min-width: 205.50pt;    \n    min-height: 290.55pt;\n}\n\n.carnet-data {\n    /* padding: 5px; */\n    width: fit-content;\n    position: absolute;\n    cursor: pointer;\n    z-index: 4;\n}\n\n.carnet-data.test-image {\n    padding: 0;\n}\n\n.carnet-data.selected{\n    border: 1px solid var(--new-green-color);\n}\n\n.carnet-data.baloa-table {\n    color: var(--primary-very-dark-color);\n    font-size: 12pt;\n}\n\n.carnet-data.image {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.carnet-data.image.selected {\n    border: 1px solid var(--new-green-color);\n}\n\n.carnet-data.image.round {\n    border-radius: 50%;\n}\n\n.carnet-data.test-image{\n    width: inherit;\n    height: inherit;\n}\n\n.carnet-data.test-image img{\n    aspect-ratio: 1;\n    object-fit: cover;\n    width: inherit;\n    height: inherit;\n    border-radius: inherit;\n}\n\n.carnet-data.test-image.selected {\n    padding: 0;\n    border: 1px solid var(--new-green-color);\n}\n\n.carnet-data.test-image.round {\n    border-radius: 50%;\n}\n\n.carnet__test-data__element {\n    margin-top: 10px;\n}\n\n.carnet__test-data__element .baloa-username {\n    color: var(--primary-very-dark-color);\n    margin-bottom: 4px;\n}\n\n.carnet__test-data__input.MuiFormControl-root {\n    width: 100%;\n}\n\n.carnet__test-data__input .MuiOutlinedInput-input {\n    padding: 12px 8px;\n}\n\n.carnet__test-data__input .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.carnet__test-data__input .MuiOutlinedInput-notchedOutline {\n    border: 1px solid var(--new-gray-background-color);\n    border-color: var(--new-gray-background-color);\n    border-radius: 8px;\n}\n.carnet__test-data__input .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n    border-color: var(--new-gray-background-color);\n    border-width: 1px;\n}\n\n.carnet__test-data__element__file-input__delete-file {\n    display: flex;\n    align-items: center;\n    margin-top: 5px;\n}\n\n.carnet__test-data__element__file-input__delete-file-icon {\n    padding: 2px 0 0 0;\n    min-width: var( --space-and-half );\n    max-width: var( --space-and-half );\n    height: var( --space-and-half );\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: var( --new-gray-background-color );\n    color: var( --primary-dark-color );\n}\n\n.carnet-print__image {\n    width: 115px;\n    height: 115px;\n    border-radius: 50%;\n}\n.carnet-preview{\n    width: 540px;\n    height: 300px;\n    position: relative;\n    border: 1px solid gray;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
